var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 62,
    viewBox: "0 0 41 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144:4395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5122 0V62C20.5122 62 0 38.6899 0 20.186C0 9.03566 9.18166 0 20.5122 0Z",
    fill: "#39A8CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0005 20.186C41.0005 38.714 20.4883 62 20.4883 62V0C31.8188 0 41.0005 9.03566 41.0005 20.186Z",
    fill: "#59CAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1697 14.5147C37.6789 6.12791 29.8159 0 20.4877 0C10.6467 0 2.41742 6.84884 0.439453 15.9566C4.17561 22.7814 11.5014 27.4194 19.9261 27.4194C28.9612 27.4194 36.7265 22.1085 40.1697 14.5147Z",
    fill: "url(#paint0_linear_1144:4395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5124 36.1906C29.845 36.1906 37.4106 28.7453 37.4106 19.5611C37.4106 10.3769 29.845 2.93164 20.5124 2.93164C11.1798 2.93164 3.61426 10.3769 3.61426 19.5611C3.61426 28.7453 11.1798 36.1906 20.5124 36.1906Z",
    fill: "#37699A",
    stroke: "#F2F2F3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5118 33.4754C28.3205 33.4754 34.6506 27.2459 34.6506 19.5614C34.6506 11.877 28.3205 5.64746 20.5118 5.64746C12.7032 5.64746 6.37305 11.877 6.37305 19.5614C6.37305 27.2459 12.7032 33.4754 20.5118 33.4754Z",
    fill: "#FAFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1144:4395",
    x1: 20.3133,
    y1: 35.7836,
    x2: 20.3133,
    y2: -9.30295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144:4395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.cd39ce4e9f73dd4a9c04254c1d5b6c54.svg";
export { ForwardRef as ReactComponent };